import React, { useEffect, useState } from "react";
import { Modal } from "semantic-ui-react";
import { IconInfoCard } from "./IconInfoCard";
import SIcon from "@iscr/views/NUI/StreamlineIcons/SIcon";

export const ModalInfoCard = (props) => {
	const [open, setIsOpen] = useState(false);
	const wrapperStyling = props?.infoCardConfig[0]?.modalWrapperStyling||"";
	const item = 'infocard_modal_dismissed';

	useEffect(() => {
		const isClosed = sessionStorage.getItem(item);
		if(!isClosed && props?.infoCardConfig[0]?.isModalOpen){
			setIsOpen(true);
			sessionStorage.setItem(item, 'true');
		}
	}, [])

	const handleClose = () => {
		setIsOpen(false);
	}

	return (
		<Modal open={open} onClose={handleClose} size="small" aria-modal="true" aria-label={props?.headerText} className={`!max-w-[550px] info-card ${wrapperStyling}`}>
			<Modal.Content className={`!p-0 relative ${wrapperStyling} [&_.basic.button_span]:!text-white`}>
				<div className="cursor-pointer bg-is2-blue-250 text-white rounded-full absolute right-2 top-2 h-10 w-10 flex items-center justify-center" onClick={handleClose}><SIcon name="close" size="xs" bold/></div>
				<IconInfoCard infoCardConfig={[{...props.infoCardConfig[0], footerStyling:"[&>p]:!text-[#99C1FA]", imageStyling: "absolute right-9 md:right-[200px] top-28 w-[100px] -rotate-[19.35deg]"}]} {...props} />
			</Modal.Content>
		</Modal>
	);
};

